export const DEFAULT_UI_LOCALE = "zh-CN" as const;
export type UiLocale = typeof DEFAULT_UI_LOCALE;

const simplified_chinese_aliases = new Set([
  "cn",
  "zh-c",
  "zh-cn",
  "chinese_simplified",
  "chinese-simplified",
]);

export function normalize_ui_locale(value: string | null | undefined): UiLocale {
  const normalized = value?.trim().toLowerCase();
  if (normalized && simplified_chinese_aliases.has(normalized)) {
    return DEFAULT_UI_LOCALE;
  }
  return DEFAULT_UI_LOCALE;
}
